<template>
    <div class="m15" ref="body" style="page-break-before: always;">
        <hr v-if="exibe === true"/>

        <h4 class="simulator-title loaded" v-if="exibe === true">Obrigações Financeiras</h4>
        <saudacao :cliente.sync="cliente.pessoa" ref="saudacao" class="saudacao"/>
        <div class="row" v-if="exibe === true">
            <div class="col l3"></div>
            <div class="col l6 s12" style="overflow: auto">
                <div style="min-width: 600px;">
                    <apexcharts
                    v-if="mostra === true"
                    ref="barchart"
                    width="100%"
                    height="350"
                    type="bar"
                    :options="options"
                    :series="options.series"
                    ></apexcharts>
                </div>
                <div class="block" style="margin-top:15px;margin-bottom:15px;" v-if="mostra === true">
                    <div align="center">Obrigações Financeiras</div>
                    <div class="total" align="center">Total: {{this.saldo}}</div>
                </div>
            </div>
            <div class="col l3"></div>
        </div>
        <div class="row" v-if="exibe === true">
        <div class="texto" style="text-align:justify">
            As informações apontam um comprometimento financeiro, <b style="font-weight:bold;">dívidas e ônus</b>, no valor de {{this.saldo}} ({{this.saldo_extenso}}) para os próximos anos.</div>
        </div>
        <div class="row" v-if="exibe === true">
        <div class="texto" style="text-align:justify">
            É importante entender se essas obrigações estão respaldadas por garantias, apólices de seguros, evitando assim a transferência desses compromissos, responsabilidades, para os herdeiros em uma eventual falta.</div>
        </div>
        <div class="row" v-if="exibe === true">
        <div class="texto" style="text-align:justify">
            Dentro do nosso desenho de soluções levamos em consideração essa necessidade de cobertura securitária das obrigações, <b style="font-weight:bold;">dívidas e ônus</b>.</div>
        </div>
    </div>
</template>

<script>
    import ApexCharts from 'apexcharts'
    import VueApexchar from 'vue-apexcharts'
    import { get } from "@/helpers/api";
    import { utils } from "../relatorios/mixins/index";
    import Saudacao from './Saudacao'
    export default {
        name:'ObrigacoesFinanceiras',
        mixins: [utils],
        components: {
            'apexcharts': VueApexchar,
            Saudacao
        },
        data () {
            return {
                db: [],
                options: {},
                image:null,
                saldo: null,
                saldo_extenso: null,
                obrigacao_financeira:[],
                exibe: false,
                mostra: false,
                image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=',


                titulo: 'Obrigações Financeiras',
            }
        },
        props: {
            cliente: {
                type: Object,
                default: null
            },
        },
        methods:{
            async plot(){

                if(this.$refs.barchart){
                    await this.$refs.barchart.chart.dataURI().then(uri => {
                        this.image = uri;
                    });
                }
                if(this.exibe === true){
                return `<div class="m15 page_logo" ref="body" id="obrigacao" style="page-break-before: always;">
                       <div class="site"></div>
                        <h4 class="simulator-title loaded">${this.titulo}</h4>
                        ${this.$refs.saudacao.plot()}
                        <div class="grafico">
                        <div class="row" style="${this.mostra !== true ?'padding-top:10px;':'padding-top: 200px;'}">

                                <img src="${this.image}" />
                                <div class="block" style="${this.mostra !== true?'display:none;':'display:block;'}">
                                    <div align="center">Obrigações Financeiras</div>
                                    <div class="total" align="center">Total: ${this.saldo}</div>
                                </div>

                        </div>
                        </div>
                        <div class="row" style="${this.mostra !== true ?'padding-top:10px;':'padding-top: 200px;'}">
                            <table>
                                <tr>
                                    <td width="100%" style="vertical-align: top;">
                                        <p style="font-size:18px;padding-bottom:30px;">
                                            As informações apontam um comprometimento financeiro, <b style="font-weight:bold;">dívidas e ônus</b>, no valor de ${this.saldo} (${this.saldo_extenso}) para os próximos anos.
                                        </p>

                                        <p style="font-size:18px;padding-bottom:30px;">
                                            É importante entender se essas obrigações estão respaldadas por garantias, apólices de seguros, evitando assim a transferência desses compromissos, responsabilidades, para os herdeiros em uma eventual falta.
                                        </p>

                                        <p style="font-size:18px;padding-bottom:30px;">
                                            Dentro do nosso desenho de soluções levamos em consideração essa necessidade de cobertura securitária das obrigações, <b style="font-weight:bold;">dívidas e ônus</b>.
                                        </p>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>`;
                }else{
                    return ''
                }
            },
            jsonToObject(j){
                return Object.keys(j).map(function(_) { return j[_]; })
            },
            readyData(...val){
                let params = val
                this.options = {
                    chart: {
                        width: "100%",
                        height: 'auto',
                        type: 'bar',
                        animations: {
                            enabled: false
                        },
                        toolbar:{
                            show:false,
                        },
                        zoom: {
                            enabled: false
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        textAnchor: 'left',
                        style: {
                            fontSize: '13px',
                            colors: ['#000']
                        },
                        formatter: function(val){
                            var numero = val.toFixed(2).split('.');
                            numero[0] = "R$ " + numero[0].split(/(?=(?:...)*$)/).join('.');
                            return numero.join(',')
                        },
                        dropShadow: {
                            enabled: false
                        }
                    },
                    series: [{
                        name:'Total',
                        data:params.map(item =>  item)
                    }],
                    grid: {
                        row: {
                            colors: ['#fff']
                        }
                    },
                    colors: ['#52dfec','#a3a0fb',],
                    xaxis: {
                        categories: ['Financiamentos','Financ. Habitacional','Emprestimos','Outros'],
                        labels: {
                            formatter: function(val){
                                return 'R$ '+val
                            }
                        }
                    },
                    legend: {
                        fontSize: '14px',
                    },
                    theme: {
                        mode: 'light',
                        palette: 'palette1'
                    },
                    tooltip:{
                        theme:'light'

                    },
                    responsive: [{
                        breakpoint: 1000,
                        options: {
                            legend: {
                                position: "bottom"
                            }
                        }
                    },
                    {
                        breakpoint: 380,
                        options:{
                            plotOptions: {
                                bar: {
                                    horizontal: true
                                }
                            },
                            legend: {
                                position: "bottom"
                            },
                        }
                    }]
                }
            },
            async getData(){


                const { obrigacao_financeira } = this.cliente;
                //console.log('obrigacao', obrigacao_financeira)


                if(obrigacao_financeira != null){
                    this.obrigacao_financeira = this.jsonToObject(obrigacao_financeira)
                }

                const financiamentos = parseFloat(this.obrigacao_financeira[1] ? this.obrigacao_financeira[1] : 0);
                const financiamento_habitacional = parseFloat(this.obrigacao_financeira[2] ? this.obrigacao_financeira[2] : 0);
                const emprestimos = parseFloat(this.obrigacao_financeira[3] ? this.obrigacao_financeira[3] : 0);
                const outros = parseFloat(this.obrigacao_financeira[6] ? this.obrigacao_financeira[6] : 0);

                if(
                    financiamentos === 0 &&
                    financiamento_habitacional === 0 &&
                    emprestimos === 0 &&
                    outros === 0
                ){
                    this.exibe = false;
                }else{
                    this.exibe = true;
                }

                if(obrigacao_financeira != null){
                    this.saldo = this.real(this.total(financiamentos, financiamento_habitacional, emprestimos, outros))
                    this.saldo_extenso = this.currency(this.total(financiamentos, financiamento_habitacional, emprestimos, outros))
                    this.db.push(financiamentos, financiamento_habitacional, emprestimos, outros);
                    this.readyData(financiamentos, financiamento_habitacional, emprestimos, outros)
                }

                if(this.db.filter(item => item != 0).length === 1){
                    this.mostra = false;
                }else{
                    this.mostra = true;
                }

            }
        },
        mounted () {
            this.getData()
        }
    }
</script>

<style lang="scss" scoped>
@import "../relatorios/Simulador.scss";
.graph{
    text-align: center;
}
.texto {
    margin-top: 15px;
    margin-bottom: 15px;
}
.m5 {
    margin-top: 15px;
}
.gridx{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/graficos-simulador/ObrigacoesFinanceiras.vue